import Terms from '@/pages/Terms'

export default {
  path: '/terms',
  name: 'terms',
  component: Terms
}



// WEBPACK FOOTER //
// ./src/router/terms.js